import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Icon } from 'common/components';
import { MAIN_ROUTES } from 'common/config/routes.config';
import { ICON_COLLECTION } from 'assets/media/icons';

import './Home.scss';

type HomeProps = {
    isSelected: boolean;
};

const Home: FC<HomeProps> = ({ isSelected }: HomeProps) => {
    const navigate = useNavigate();

    const goToHome = () => {
        navigate(MAIN_ROUTES.HOME);
    };

    return (
        <span title="Home" onClick={() => goToHome()} className="home-icon-container">
            <Icon
                className="home-icon"
                src={
                    isSelected ? ICON_COLLECTION.IC_Home_Selected : ICON_COLLECTION.IC_Home_Default
                }
            />
        </span>
    );
};

export default Home;
